import { Component, OnInit } from "@angular/core";
import { GrowthBookService } from "./shared/services/growthbook.service";
import { loadGrowthBookFeatures } from "./shared/growthbook";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
    constructor(private growthBookService: GrowthBookService) {}

    ngOnInit(): void {
        // Carrega as features do GrowthBook
        loadGrowthBookFeatures();

        // Define os atributos do GrowthBook se o usuário estiver logado
        this.growthBookService.setUserAttributes();
    }
}
